import { createSlice } from '@reduxjs/toolkit';
import {
  getAllConnectorsAction,
  getConnectorCategoriesAction,
  getConnectorsInputsAction,
} from 'redux/actions/connector';

const initialState = {
  connectors: [],
  connectorCategories: [],
  connectorInputs: [],
  loading: false,
};

// First import your thunk then add thunk lifecycle handlers
const connectorSlice = createSlice({
  name: 'connector',
  initialState,
  reducers: {},
  extraReducers: {
    [getAllConnectorsAction.pending]: (state) => {
      state.loading = true;
    },
    [getAllConnectorsAction.fulfilled]: (state, action) => {
      state.connectors = action.payload;
      state.loading = false;
    },
    [getAllConnectorsAction.rejected]: (state) => {
      state.loading = false;
    },
    [getConnectorCategoriesAction.pending]: (state) => {
      state.loading = true;
    },
    [getConnectorCategoriesAction.fulfilled]: (state, action) => {
      state.connectorCategories = action.payload;
      state.loading = false;
    },
    [getConnectorCategoriesAction.rejected]: (state) => {
      state.loading = false;
    },
    [getConnectorsInputsAction.pending]: (state) => {
      state.loading = true;
    },
    [getConnectorsInputsAction.fulfilled]: (state, action) => {
      state.connectorInputs = action.payload;
      state.loading = false;
    },
    [getConnectorsInputsAction.rejected]: (state) => {
      state.loading = false;
    },
  },
});

// export auto-generated action creators from the reducer
export const actions = connectorSlice.actions;
// export the reducer to be passed to configureStore
export default connectorSlice.reducer;
